import _ from "lodash";
import {
  SELECTED_COMPANY_USER,
  CREATE_COMPANY_USER,
  FETCH_COMPANY_USERS,
  FETCH_COMPANY_USER,
  EDIT_COMPANY_USER,
  DELETE_COMPANY_USER,
} from "../actions/types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = {}, action) => {
  switch (action.type) {
    case SELECTED_COMPANY_USER:
      return { ...state, [action.payload.id]: action.payload };
    case FETCH_COMPANY_USERS:
      return { ...state, ..._.mapKeys(action.payload["hydra:member"], "id") };
    case FETCH_COMPANY_USER:
      return { ...state, [action.payload.id]: action.payload };
    case CREATE_COMPANY_USER:
      return { ...state, [action.payload.id]: action.payload };
    case EDIT_COMPANY_USER:
      return { ...state, [action.payload.id]: action.payload };
    case DELETE_COMPANY_USER:
      return _.omit(state, action.payload);

    default:
      return state;
  }
};
